<template>
  <el-dialog
    :close-on-click-modal="false"
    title="车辆详情"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box
        :data="carData"
        :colNum="1"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      carData: {
        label: '车辆信息',
        tableData: {
          title: [
            {
              prop: 'carDriverMan',
              label: '司机',
            },
            {
              prop: 'carDriverPhone',
              label: '手机',
            },
            {
              prop: 'vehicleClassName',
              label: '车型',
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.carData.tableData.data = item;
    },

  },
};
</script>

<style>
</style>
